export const Settings = {
    // Auto-Offer Settings
    UPDATE_LENDER_SETTINGS: "settings.lender.update",
    UPDATE_BORROWER_SETTINGS: "settings.borrower.update",
    UPDATE_AO_SETTINGS: "settings.ao.update",
    UPDATE_ACCOUNT_SETTINGS: "settings.account.update",
    UPDATE_EMAIL_SETTINGS: "settings.emails.update",
    UPDATE_CONFIRMATION_FILE_FIELDS: "settings.confirmation_file_fields.update",
    UPDATE_USER_SETTINGS: "settings.user_settings.update",
    UPDATE_PEER_CPTY_SETTINGS: "settings.peer_cpty.update",
    ADD_LIST_SETTINGS: "settings.list.add",
    ADD_PENDING_LIST_SETTINGS: "settings.list.pending.add",
    CLEAR_PENDING_LIST_SETTINGS: "settings.list.pending.clear",
    ADD_PENDING_BLOCKED_SECURITY: "settings.security.add_pending_blocked",
    SET_PENDING_BLOCKED_SECURITY: "settings.security.set_pending_blocked",
    REMOVE_PENDING_BLOCKED_SECURITY: "settings.security.remove_pending_blocked",
    UPDATE_LIST_SETTINGS: "settings.list.update",
    REMOVE_LIST_SETTINGS: "settings.list.remove",
    SET_LIST_SETTINGS: "settings.list.set",
    SET_DELETED_LIST: "settings.list.set_deleted",
    DISPLAY_NEW_LIST_ERRORS: "settings.list.display.errors",
    ADD_FUND_SETTINGS: "settings.fund.add",
    REMOVE_FUND_SETTINGS: "settings.fund.remove",
    SET_FUND_SETTINGS: "settings.fund.set",
    SET_DELETED_FUND: "settings.fund.set_deleted",
    DISPLAY_NEW_FUND_ERRORS: "settings.fund.display.errors",
    RESET_SETTINGS: "settings.reset", // for unit test
    SET_LD_FEATURE_FLAGS: "settings.ld_feature_flags.set",
    UPDATE_LD_FEATURE_FLAGS: "settings.ld_feature_flags.update",
    SET_SELECTED_PEER_CPTY_SETTING:
        "settings.peer_cpty.setSelectedPeerCptySetting",
    UPDATE_CPTY_SECRET_KEY: "settings.peer_cpty.update_secret_key",
    SET_NEW_PEER_CPTY_SETTING: "settings.peer_cpty.setNewPeerCptySetting",
    SET_GENERAL_ACCOUNT_SETTING: "settings.general_account.set",
};
